
const isObject = item => (item && typeof item === 'object' && !Array.isArray(item))

export function clone(obj) {
  if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj)
    return obj;

  if (obj instanceof Date)
    var temp = new obj.constructor(); //or new Date(obj);
  else
    var temp = obj.constructor();

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj['isActiveClone'] = null;
      temp[key] = clone(obj[key]);
      delete obj['isActiveClone'];
    }
  }
  return temp;
}
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, {[key]: {}});
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}
export const getPathReference = (obj, path) => {
  const splitted = path.split(".")
  if (splitted.length === 1) return obj[path]
  const key = splitted.shift()
  return getPathReference(obj[key], splitted.join('.'))
}

export const unmappObject = maps => {
  const result = {}
  const paths = Object.keys(maps).filter(key => maps[key])

  const mapContentToPath = (path, target, value, previousTarget, previousKey) => {
    if (!path.length || !target) return;
    let key = path[0]

    const next = (nextTarget = target[key]) => {
      const previousKey = path.shift()
      mapContentToPath(path, nextTarget, value, target, previousKey)
    }
    const isArr = someKey => /\[\d\]/.test(someKey + '')

    if (path.length === 1) {
      target[key] = value
    } else if (isArr(key)) {
      const index = parseInt(key.substring(1), 10)
      if (!previousTarget[previousKey] || !Array.isArray(previousTarget[previousKey])) {
        if (!isArr(previousKey)) previousTarget[previousKey] = []
      }

      if (!previousTarget[previousKey][index]) previousTarget[previousKey].push({})

      return next(previousTarget[previousKey][index])
    } else {
      target[key] = Array.isArray(target[key]) ? [...target[key]] : {...target[key]}
    }

    next()
  }

  for (const path of paths) {
    mapContentToPath(path.split(/(\.)|(\[\d\])/).filter(item => item && item !== '.'), result, maps[path])
  }

  return result
}
export function mapObject(obj) {
  const maps = {}

  const walk = (obj, path = "") => {
    const keys = Object.keys(obj)

    keys.forEach(key => {
      const val = obj[key]
      const newPath = path + key

      if (typeof val !== 'object') {
        maps[newPath] = val
      } else if (Array.isArray(val)) {
        val.forEach((arrayObj, index) => {
          walk(arrayObj, newPath + `[${index}]`)
        })
      } else {
        walk(obj[key], newPath + ".")
      }
    })
  }

  walk(obj)
  return maps
}